import * as React from "react"

import { cn } from "../helpers/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, error, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-lg border-gray-300 bg-white px-5 py-1.5 text-base outline-none ring-0 placeholder:text-muted-foreground hover:border-black focus:border-gray-200 focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50",
        className,
        { "border-red-500 bg-red-100": error }
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
